import { WorkoutsState, InitialState, ModuleAction, Types } from './workouts.model';

export function WorkoutsReducer(s: WorkoutsState = InitialState, a: ModuleAction): WorkoutsState {
  if (!a) { return s; }
  switch (a.type) {
    case Types.UpdateState: return { ...s, ...a.payload };
    default: return s;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/store/workouts.reducer.ts